import { UseMutationResult, useMutation, useQueryClient } from "react-query";

import { useAuth } from "../../sdk/hooks";
import { api } from "../../sdk/utils";
import * as types from "../../sdk/types/api";

export const useRecalculateCustomerShoppingList = (
    invalidQueryKeys: string | (string | number)[],
): UseMutationResult<types.IShoppingList, unknown, { customerId: string }> => {
    const auth = useAuth();
    const queryClient = useQueryClient();

    return useMutation<types.IShoppingList, unknown, { customerId: string }>({
        mutationFn: async (parameters: { customerId: string }) => {
            if (!auth.token) {
                throw new Error("Cannot save without authorization token.");
            }
            return await api.ShoppingLists.recalculateForCustomer(parameters.customerId, auth.token);
        },
        onSuccess: () => {
            queryClient.invalidateQueries(invalidQueryKeys);
        },
    });
};
